import { Check } from "lucide-react";
import { EmailIcon } from "../icons";

export const EmailInput = ({
  register,
  validationError,
  emailValue,
  focusedField,
  setFocusedField,
  handleKeyDown,
}) => {
  const isFocused = focusedField === "email";

  return (
    <div>
      <label
        htmlFor="email"
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        Email address
      </label>
      <div
        className={`relative rounded-md ${
          isFocused ? "ring-2 ring-indigo-500" : ""
        }`}
      >
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <EmailIcon
            className={`h-5 w-5 ${
              isFocused ? "text-indigo-500" : "text-gray-400"
            }`}
          />
        </div>
        <input
          {...register("email")}
          id="email"
          name="email"
          type="email"
          onFocus={() => setFocusedField("email")}
          onBlur={() => setFocusedField(null)}
          onKeyDown={handleKeyDown}
          aria-invalid={!!validationError}
          aria-describedby={validationError ? "email-error" : undefined}
          className={`block w-full pl-10 pr-3 py-3 border ${
            validationError ? "border-red-300" : "border-gray-300"
          } rounded-lg shadow-sm`}
          placeholder="Email Address"
        />
        {emailValue && !validationError && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <Check className="h-5 w-5 text-green-500" />
          </div>
        )}
      </div>
      {validationError && (
        <p className="mt-2 text-sm text-red-600" id="email-error">
          {validationError.message}
        </p>
      )}
    </div>
  );
};
